import { RootState } from '~store/root.reducer'
import { createSelector } from 'reselect'

const selectSpareAxleRequestState = (state: RootState) => state.spareAxleRequestWizard

export const getSpareAxleRequestFormData = createSelector(
  selectSpareAxleRequestState,
  state => state.data)

export const getSpareAxleRequestFormCurrentStep = createSelector(
  selectSpareAxleRequestState,
  state => state.currentStep,
)
